import { gql } from '@apollo/client'

export const GetRecurrentChargesByLeaseId = gql`
  query GetRecurrentChargesByLeaseId($leaseId: String!) {
    recurrentChargesByLeaseId(leaseId: $leaseId) {
      recurrent_charge_id
      description
      amount
      gl_code
      gl_account_name
      frequency_name
      start_date
      end_date
      active
      last_month_proration_amount
      last_month_proration_date
      second_month_proration_amount
      second_month_proration_date
    }
  }
`

export const GetLeaseChargesByLeaseId = gql`
  query GetLeaseChargesByLeaseId($leaseId: String!) {
    leaseChargesByLeaseId(leaseId: $leaseId) {
      charge_id
      lease_id
      charge_status_id
      description
      amount
      amount_balance
      charge_date
      active
    }
  }
`
